import React from "react";
import {
  calculateInvoiceDiscountAmount,
  formatInvoiceDiscountLabel,
  isValidCustomDiscountAmount,
} from "../../utilis/invoiceDiscountHelpers";
import { formatInvoiceMoney } from "../../utilis/invoiceLineItemHelpers";

function InvoiceLineDiscountRow({
  discountTab = "predefined",
  onDiscountTabChange,
  discountRules = [],
  selectedRuleId = "",
  onSelectedRuleIdChange,
  customAmount = "",
  onCustomAmountChange,
  reason = "",
  onReasonChange,
  grossSubtotal = 0,
  totalAmount = 0,
  error = "",
  editMode = false,
  isDiscountUpdate = false,
  onUpdateDiscount = null,
  onCancelDiscountEdit = null,
  updatingDiscount = false,
}) {
  const previewAmount = calculateInvoiceDiscountAmount({
    tab: discountTab,
    ruleId: selectedRuleId,
    rules: discountRules,
    customAmount,
    grossSubtotal,
    maxTotal: totalAmount,
  });
  const showPreviewRow =
    previewAmount > 0 ||
    (discountTab === "custom" && isValidCustomDiscountAmount(customAmount));

  return (
    <>
      <tr className="invoice-xero-lines-table__discount-row">
        <td colSpan={3}>
          <div className="invoice-line-discount__head">
            <span className="invoice-line-discount__title">Discount</span>
            <div
              className="invoice-line-discount__tabs"
              role="tablist"
              aria-label="Discount type"
            >
              <button
                type="button"
                role="tab"
                aria-selected={discountTab === "predefined"}
                className={`invoice-line-discount__tab${
                  discountTab === "predefined" ? " is-active" : ""
                }`}
                onClick={() => onDiscountTabChange?.("predefined")}
              >
                Percentage
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={discountTab === "custom"}
                className={`invoice-line-discount__tab${
                  discountTab === "custom" ? " is-active" : ""
                }`}
                onClick={() => onDiscountTabChange?.("custom")}
              >
                Custom
              </button>
            </div>
          </div>
        </td>
        <td className="text-end invoice-line-discount__value-cell">
          {discountTab === "predefined" ? (
            <select
              className="invoice-xero-lines-table__select invoice-line-discount__select"
              value={selectedRuleId}
              onChange={(event) =>
                onSelectedRuleIdChange?.(event.target.value)
              }
            >
              <option value="">Choose rule…</option>
              {discountRules.map((rule) => (
                <option key={rule.id} value={rule.id}>
                  {formatInvoiceDiscountLabel(rule)}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="number"
              min="0"
              step="0.01"
              className="invoice-xero-lines-table__input invoice-xero-lines-table__input--num invoice-line-discount__amount"
              placeholder="0.00"
              value={customAmount}
              onChange={(event) => onCustomAmountChange?.(event.target.value)}
            />
          )}
        </td>
        <td colSpan={4}>
          <input
            type="text"
            className="invoice-xero-lines-table__input invoice-line-discount__reason"
            placeholder="Reason for discount"
            value={reason}
            onChange={(event) => onReasonChange?.(event.target.value)}
          />
        </td>
        <td className="invoice-xero-lines-table__actions-col">
          {editMode ? (
            <div className="invoice-line-discount__actions">
              {onCancelDiscountEdit ? (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary invoice-line-discount__cancel-btn"
                  onClick={() => onCancelDiscountEdit?.()}
                  disabled={updatingDiscount}
                >
                  Cancel
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-sm btn-primary invoice-line-discount__update-btn"
                onClick={() => onUpdateDiscount?.()}
                disabled={updatingDiscount}
              >
                {updatingDiscount
                  ? "Updating…"
                  : isDiscountUpdate
                    ? "Update discount"
                    : "Apply discount"}
              </button>
            </div>
          ) : null}
        </td>
      </tr>

      {showPreviewRow ? (
        <tr className="invoice-xero-lines-table__discount-applied-row">
          <td colSpan={7} className="invoice-line-discount__applied-label text-end">
            Discount applied
          </td>
          <td className="text-end fw-semibold invoice-line-discount__applied-amount">
            -{formatInvoiceMoney(previewAmount, "", {})}
          </td>
          <td />
        </tr>
      ) : null}

      {error ? (
        <tr className="invoice-xero-lines-table__discount-error-row">
          <td colSpan={9}>
            <div className="invoice-xero-lines-table__error">{error}</div>
          </td>
        </tr>
      ) : null}
    </>
  );
}

export default InvoiceLineDiscountRow;
